import { Outlet, Navigate } from 'react-router-dom';
import { hasStudentToken } from '../http/index';
import { hasTeacherToken } from '../http/index2';

const PrivateRoutes = () => {
    // Tokens live in memory (not sessionStorage) after SEC #8 fix.
    // Fall back to sessionStorage isAuth flags so refresh/direct-nav still works
    // until the in-memory token is re-populated via the 401 interceptor.
    const memoryOk = hasStudentToken() || hasTeacherToken();
    const sessionOk = sessionStorage.getItem('isAuthUser') === 'true'
        || sessionStorage.getItem('isAuthTeacher') === 'true';
    return memoryOk || sessionOk ? <Outlet /> : <Navigate to="/login" />;
}

export default PrivateRoutes;

